import React from 'react';
import {SearchBox} from 'searchkit';
import {webshop} from "./webshop";

class CustomSearchBox extends SearchBox {
  componentDidMount() {
    if (typeof webshop.query === 'string' && webshop.query.length > webshop.minLength) {
      this.accessor.setQueryString(webshop.query)
      this.forceUpdate()
    }
  }

  render() {
    const { buttonLabel } = this.props;
    let block = this.bemBlocks.container

    return (
      <div className={block().state({focused:this.state.focused})}>
        <form onSubmit={this.onSubmit.bind(this)}>
          <div className={block("icon")}></div>
          <input type="text"
          data-qa="query"
          className={block("text")}
          placeholder={this.props.placeholder || this.translate("searchbox.placeholder")}
          value={this.getValue()}
          onFocus={this.setFocusState.bind(this, true)}
          onBlur={this.setFocusState.bind(this, false)}
          ref="queryField"
          autoFocus={this.props.autofocus}
          onInput={this.onChange.bind(this)}/>
          <button type="submit" className={block("action")} data-qa="submit">{buttonLabel}</button>
          <div data-qa="loader" className={block("loader").mix("sk-spinning-loader").state({hidden:!this.isLoading()})}></div>
        </form>
      </div>
    );

  }
}

export default CustomSearchBox



// WEBPACK FOOTER //
// ./src/SearchBox.js